import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Typography, Form, Button, Row, Col, Icon } from 'antd'
import moment from 'moment'
import { Link } from 'react-router-dom'

const { Text, Title } = Typography


class ListCalendarMeeting extends Component {
	state = {
	}
	render() {
		const { dataMeeting, date, typeMeeting } = this.props
		const { getFieldDecorator } = this.props.form;
		console.log("date",date);
		return (
			<Row gutter={16} type="flex">
				{
               dataMeeting.length > 0 ?
                  dataMeeting.map((MeetingList, i) => {
                     if (date == moment(MeetingList.startdate).format('DD-MM-YYYY') && typeMeeting == MeetingList.status) {
                        return (
                           <Col key={i} span={24} className={"box-show-calendar-meeting my-2 py-2"} >
                              <Link
                                 to={{
                                    pathname: `/meetingmanagement/inviteMeetingForm/`,
                                    search: 'id=' + MeetingList.meetingID + '&status=' + MeetingList.status + '&from=/meetingmanagement/meeting',
                                 }}>
                                 <Row gutter={16} className={"ml-1"} style={{ borderLeft: "8px solid", borderColor: (MeetingList.status == "Join" ? "#178991" : (MeetingList.status == "Refuse" ? "#D94339" : (MeetingList.status == "Waiting" ? "#faad14" : "#CCCCCC"))) }}>
                                    <Col span={21} style={{ color: "#666666" }}>
                                       <p className='text-calendar-title m-1'>{MeetingList.subject}</p>
                                       <p className='text-calendar-description m-1'>{moment(MeetingList.startdate).format('HH:mm')}-{moment(MeetingList.enddate).format('HH:mm')}</p>
                                    </Col>
                                    <Col span={1} align="end">
                                       <Icon className='mt-3' type="right" style={{ color: "#666666" }} />
                                    </Col>
                                 </Row>
                              </Link>
                           </Col>
                        )
                     }
                  })
               : 
                  <Col span={24}>
                     <p style={{ fontSize:"15px" }} className="pl-3">ไม่พบข้อมูลรายการ</p>
                  </Col>
            }
			</Row >
		)
	}
}


ListCalendarMeeting.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedAddMeeting = Form.create()(ListCalendarMeeting)

export default withApollo(WrappedAddMeeting)